import { useQuery } from '@apollo/client';
import {USER_BY_ID} from "../userTypeDefs";

export const useQueryUserById = (options?: any): any => (
  useQuery(USER_BY_ID, options)
);
